import i18n from 'i18next';

export default ({ adminSettings: { data = {} } }) => {
  return data.available_event_types?.map((type, i) => {
    const eventType = type === 'physical' ? 'url' : type;
    const eventLabel = i18n.t(eventType.replace(/_/g, '-'));

    return {
        id: i,
        label: eventLabel,
        value: eventType,
    };
  });
};
